import React, { useEffect, useState } from "react";
import { useEvent } from "@/context/EventContext";

const InfoPanel = ({ eventId, tableName, sessionName }) => {
  const [panelShow, setPanelShow] = useState(false);
  const { fetchEventById, eventById } = useEvent();
  
  const currentEvent = eventById[eventId] || null;

  useEffect(() => {
    if (eventId) {
      fetchEventById(eventId);
    }
  }, [fetchEventById, eventId]);

  return (
    <>
      {!panelShow && (
        <div className="gm-chat-shell">
          <div className="gm-chat-panel">
            <div className="gm-chat-header">
              <div className="gm-chat-headerLeft">
                <div className="gm-chat-headerIcon">
                  <i className="fa-solid fa-calendar-days"></i>
                </div>

                <div>
                  <div className="gm-chat-title">Event Details</div>
                  <div className="gm-chat-subtitle">
                    View complete event information
                  </div>
                </div>
              </div>

              <button
                onClick={() => setPanelShow(true)}
                className="jt-mobileDrawerClose"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div className="ev-panel">
              <div className="ev-card">
                <div className="ev-header">
                  <h2 className="ev-title">{currentEvent?.eventName}</h2>

                  <div className="ev-tag">
                    <i className="fas fa-bolt"></i>
                    <span>Live Event</span>
                  </div>
                </div>

                <div className="ev-meta">
                  {sessionName && (
                    <div className="ev-metaItem">
                      <div className="ev-metaLabel">
                        <i className="fas fa-chalkboard"></i>
                        <span>Session</span>
                      </div>
                      <div className="ev-metaValue">{sessionName}</div>
                    </div>
                  )}

                  {tableName && (
                    <div className="ev-metaItem">
                      <div className="ev-metaLabel">
                        <i className="fas fa-table"></i>
                        <span>Table</span>
                      </div>
                      <div className="ev-metaValue">{tableName}</div>
                    </div>
                  )}

                  <div className="ev-metaItem">
                    <div className="ev-metaLabel">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>Venue</span>
                    </div>

                    <div className="ev-metaValue">{currentEvent?.venue}</div>
                  </div>

                  <div className="ev-metaItem">
                    <div className="ev-metaLabel">
                      <i className="fas fa-user-tie"></i>
                      <span>Organizer</span>
                    </div>

                    <div className="ev-metaValue">
                      {currentEvent?.chapterName}
                    </div>
                  </div>
                </div>

                <div className="ev-description">
                  <div className="ev-descriptionTitle">
                    <i className="fas fa-circle-info"></i>
                    <span>About This Event</span>
                  </div>

                  <div
                    className="ev-descriptionContent"
                    dangerouslySetInnerHTML={{
                      __html: currentEvent?.description || "",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoPanel;
